import { render } from "./RepairAddressListView.vue?vue&type=template&id=185f9966&scoped=true"
import script from "./RepairAddressListView.vue?vue&type=script&lang=js"
export * from "./RepairAddressListView.vue?vue&type=script&lang=js"

import "./RepairAddressListView.vue?vue&type=style&index=0&id=185f9966&scoped=true&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185f9966"]])

export default __exports__